import type { MediaRef } from '../api';
export interface StudioSpec {
 name: string;
 brief: string;
 instructions: string;
 provider: 'fal' | 'openrouter';
 imageModel: string;
 videoModel: string;
 videoProvider?: 'fal' | 'openrouter';
 imageStyle?: StudioImageStyle;
 useDefaults?: boolean;
 kind: 'photo' | 'reel' | 'mixed';
 count: number;
 startDate: string;
 time: string;
 everyDays: number;
 autoSchedule: boolean;
}
export interface StudioJob {
 id: string; planName?: string; batchId: string; ordinal: number; kind: 'photo'|'reel'; status: string;
 prompt: string | null; media: MediaRef | null; caption: string | null;
 postId: string | null; error: string | null; scheduledAt: number | null;
}
export interface StudioModel { id: string; name: string; kind: 'photo'|'reel' }
export interface StudioSettings {
 falConnected: boolean; openrouterConnected: boolean;
 defaults: StudioDefaults;
 models: { fal: StudioModel[]; openrouter: StudioModel[] };
}

export const STUDIO_IMAGE_STYLES = ['image', 'infographic', 'realistic', 'meme'] as const;
export type StudioImageStyle = typeof STUDIO_IMAGE_STYLES[number];
export type StudioTask = StudioImageStyle | 'video';
export type StudioDefaults = Partial<Record<StudioTask, {provider: 'fal'|'openrouter'; model: string}>>;
export const STUDIO_TASK_INFO: Record<StudioTask, {label:string; description:string}> = {
 image: {label:'Images & illustrations',description:'Original artwork and visual posts.'},
 infographic: {label:'Infographics',description:'Clear diagrams and layouts with readable labels and verified facts.'},
 realistic: {label:'Realistic photos',description:'Photorealistic scenes with natural lighting and lifelike details.'},
 meme: {label:'Memes',description:'Humorous visual posts with concise, readable on-image text.'},
 video: {label:'Videos & Reels',description:'Vertical moving footage for Instagram Reels.'},
};
export function applyStudioDefaults(spec:StudioSpec, defaults:StudioDefaults):StudioSpec {
 const image=defaults[spec.imageStyle??'image']; const video=defaults.video;
 return {...spec,...(image?{provider:image.provider,imageModel:image.model}:{}),
  videoProvider:video?.provider??spec.videoProvider??spec.provider,
  ...(video?{videoModel:video.model}:{})};
}
export function studioProvider(spec:StudioSpec,kind:'photo'|'reel') {
 return kind==='reel' ? spec.videoProvider??spec.provider : spec.provider;
}
